import { Injectable } from '@angular/core';
import { NL_ProgramAyarlari } from './../../models/NL_ProgramAyarlari';
import { Database } from './../database';
import 'rxjs/add/operator/map';

@Injectable()
export class BllProgramAyarlari extends Database{
    constructor()
    {
        super("NL_ProgramAyarlari");
    }
    CariListeSayisiGuncelle(guncellenecekElement:NL_ProgramAyarlari){
        return new Promise((res,err)=>{
          this.execRawQueryWithParams("update NL_ProgramAyarlari set CariListeSayisi = ? where ID = ?",[guncellenecekElement.CariListeSayisi,guncellenecekElement.ID]).then(a=>{
            res(a);
          }).catch(x=>{
            err(x);
          })
        })
      }
      MalzemeListeSayisiGuncelle(guncellenecekElement:NL_ProgramAyarlari){
        return new Promise((res,err)=>{
            this.execRawQueryWithParams("update NL_ProgramAyarlari set MalzemeListeSayisi = ? where ID = ?",[guncellenecekElement.MalzemeListeSayisi,guncellenecekElement.ID]).then(a=>{
              res(a);
            }).catch(x=>{
              err(x);
            })
          })

      }
      SatisFaturasiAyariGuncelle(guncellenecekElement:NL_ProgramAyarlari)
      {
        return new Promise((res,err)=>{
            this.execRawQueryWithParams("update NL_ProgramAyarlari set SatisFaturasiStoktanDusecekMi = ? where ID = ?",[guncellenecekElement.SatisFaturasiStoktanDusecekMi,guncellenecekElement.ID]).then(a=>{
              res(a);
            }).catch(x=>{
              err(x);
            })
          })
      }
      FisYaziciAdiGuncelle(guncellenecekElement:NL_ProgramAyarlari)
      {
        return new Promise((res,err)=>{
            this.execRawQueryWithParams("update NL_ProgramAyarlari set FisYaziciAdi = ? where ID = ?",[guncellenecekElement.FisYaziciAdi,guncellenecekElement.ID]).then(a=>{
              res(a);
            }).catch(x=>{
              err(x);
            })
          })
      }
      BarkodYaziciGuncelle(guncellenecekElement:NL_ProgramAyarlari)
      {
        return new Promise((res,err)=>{
            this.execRawQueryWithParams("update NL_ProgramAyarlari set BarkodYaziciAdi = ? where ID = ?",[guncellenecekElement.BarkodYaziciAdi,guncellenecekElement.ID]).then(a=>{
              res(a);
            }).catch(x=>{
              err(x);
            })
          })
      }
      FisYaziciOtomatigiGuncelle(guncellenecekElement:NL_ProgramAyarlari)
      {
        return new Promise((res,err)=>{
            this.execRawQueryWithParams("update NL_ProgramAyarlari set fisyazicioto = ? where ID = ?",[guncellenecekElement.fisyazicioto,guncellenecekElement.ID]).then(a=>{
              res(a);
            }).catch(x=>{
              err(x);
            })
          })
      }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-programayarlari.ts